export const METRIC_SCALE = '5 km';
export const METRIC_ZOOM_SCALE = '1 km';
export const IMPERIAL_SCALE = '2 mi';
export const IMPERIAL_ZOOM_SCALE = '0.4 mi';
